import config from 'netxcore@netx/core-cms/config';

Object.assign(config, {
	analytics: {
		google: {
			enabled: false,
			trackingId: '',
		},
	},
	collections: {
		maxNumberDisplay: 999,
	},
	copyright: 'NetX',
	tagline: 'Welcome',
});

export default config;
